import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

import { Query as RootQuery } from 'graphql/models/generated';

export const MATERIAL_AND_EAN_CODES_QUERY = gql`
  query materialAndEanCodes(
    $documentVersion: DocumentVersionInput!
    $lineIds: [String!]
  ) {
    materialAndEanCodes(
      documentVersion: $documentVersion,
      lineIds: $lineIds
    ) {
      lineId
      door {
        ean
        materialNumber
        ZUSATZ8
        GKNZ_1
      }
      door2 {
        ean
        materialNumber
        ZUSATZ8
        GKNZ_1
      }
      frame {
        ean
        materialNumber
        ZUSATZ8
        GKNZ_1
      }
      custom {
        ean
        materialNumber
        ZUSATZ8
        GKNZ_1
      }
    }
  }
`;

@Injectable({ providedIn: 'root' })
export class MaterialAndEanCodesQuery extends Query<RootQuery> {
  document = MATERIAL_AND_EAN_CODES_QUERY;
}
